import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox"]

    connect() {
        this.sync()
    }

    toggleDay(event) {
        event.preventDefault()
        const day = event.currentTarget.dataset.day
        const boxes = this.dayCheckboxes(day)
        const allChecked = boxes.length > 0 && boxes.every((box) => box.checked)

        this.setChecked(boxes, !allChecked)
    }

    toggleTime(event) {
        event.preventDefault()
        const time = event.currentTarget.dataset.time
        const boxes = this.timeCheckboxes(time)
        const allChecked = boxes.length > 0 && boxes.every((box) => box.checked)

        this.setChecked(boxes, !allChecked)
    }

    selectFullTime(event) {
        event.preventDefault()
        this.clearSelections()

        const days = ["mon", "tue", "wed", "thu", "fri"]
        const times = ["mor", "aft"]

        this.checkCombination(days, times, true)
    }

    selectWeekend(event) {
        event.preventDefault()
        this.clearSelections()

        const days = ["sat", "sun"]
        const times = ["mor", "aft", "eve", "ona", "ons"]

        this.checkCombination(days, times, true)
    }

    selectNights(event) {
        event.preventDefault()
        this.clearSelections()

        const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]
        const times = ["ona", "ons"]

        this.checkCombination(days, times, true)
    }

    clearAll(event) {
        if (event) event.preventDefault()
        this.clearSelections()
    }

    sync() {
        // hook left intentionally simple for future UI summaries
    }

    dayCheckboxes(day) {
        return this.checkboxTargets.filter((box) => box.dataset.day === day)
    }

    timeCheckboxes(time) {
        return this.checkboxTargets.filter((box) => box.dataset.time === time)
    }

    checkboxFor(day, time) {
        return this.checkboxTargets.find(
            (box) => box.dataset.day === day && box.dataset.time === time
        )
    }

    setChecked(boxes, value) {
        boxes.forEach((box) => {
            box.checked = value
            box.dispatchEvent(new Event("change", { bubbles: true }))
        })
    }

    checkCombination(days, times, value) {
        days.forEach((day) => {
            times.forEach((time) => {
                const box = this.checkboxFor(day, time)
                if (box) {
                    box.checked = value
                    box.dispatchEvent(new Event("change", { bubbles: true }))
                }
            })
        })
    }

    clearSelections() {
        this.setChecked(this.checkboxTargets, false)
    }
}